<div class="content-section" [ngClass]="layoutService.expandedMenu ? 'expand' : ''">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-section title-bar title-bar-nav">
        <div class="title-div">
            <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                <div class="col-auto">
                    <h2 class="background_title">{{ 'SOP_OBSERVATION.SOP_OBSERVATION' | translate }}</h2>
                </div>
                <!-- <div class="col-auto d-flex justify-content-md-end justify-content-sm-start">
                    <div class="col-auto institution-name p-0">
                        <img src="assets/img/menuActive/Institution.svg" alt="Institution">
                        <p class="m-0 selectedInsText cursor" *ngIf='showInstitutionDropDown()'>
                            {{selectedInstitution}}
                            <a class="menuLink tooltipEvalution">
                                <img src="assets/img/svg/icon-change.svg"> (click)="openmodal(template)"
                                <span class="tooltiptext">{{ 'LAYOUT_MODULE.CHANGE_INSTITUTION' | translate }}</span>
                            </a> 
                        </p>
                        <p class="m-0" *ngIf='!showInstitutionDropDown()'>{{getInstitutionName()}}</p>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="container-nav">
            <nav class="nav nav-pills nav-title">
                <a class="nav-link" routerLink="/sopObserve/newObserve" routerLinkActive='active'>{{ 'SOP_OBSERVATION.NEW_OBSERVATION' | translate }}</a>
                <a class="nav-link" routerLink="/sopObserve/observeProtocol" routerLinkActive='active'>{{ translationKeys.SOPObservation.ObservationProtocol | translate }}</a>
                <a class="nav-link" routerLink="/sopObserve/sopEditor" routerLinkActive='active' *ngIf="isSopEditorAvailable()">{{ 'LAYOUT_MODULE.SOP_EDITOR' | translate }}</a>
            </nav>
            <hr class="nav-separator">
        </div>
    </div>

    <div class="sop-navigation container-fluid">
        <router-outlet></router-outlet>
    </div>
</div>

<ng-template #template>
    <div class="modal-header justify-content-between align-items-center">
        <!-- <h5 class="modal-title" id="exampleModalLabel">{{ translationKeys.UserProfiles.SelectInsititutions | translate }}</h5> -->
        <a class="cursor" aria-label="Close" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar class="change-lang">
        <div [formGroup]="mygroup" class="col-12">
            <div class="mb-2 form-check" *ngFor='let Institutions of InstitutionsList;let i = index'>
                <input type="radio" [value]="Institutions.institution.institutionID" name="selectedIns" *ngIf="showInstitutionDropDown()" formControlName="selectedIns" class="form-check-input" id={{Institutions.institution.institutionID}}>
                <label class="form-check-label" for={{Institutions.institution.institutionID}}>{{Institutions.institution.institutionName}}</label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-6 my-3">
                    <button type="button" class="btn btn-block btn-primary" (click)="modalRef.hide();onInstitutionChange(mygroup.value.selectedIns);">{{ translationKeys.Authorization.Done | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>